export default {
  'language.usd': 'Доллар',
  'language.eur': 'евро',
  'language.rub': 'натирать',
  'language.rial': 'Риял',
  'language.persian': 'Фарси',
  'language.german': 'Deutsche',
  'language.italian': 'Italiano',
  'language.arabic': 'عربی',
  'language.french': 'Français',
  'language.spanish': 'Español',
  'language.russian': 'русский',
  'language.english': 'English',
  'language.japanese': 'Японский',
  'language.yen': 'иена',
  'language.iran': 'فارسی',
  'component.select': 'Выбрать',
  'form.requierd': 'ТРЕБУЕТСЯ',
  'form.isshort': 'Слишком короткий',
  'form.islong': 'Слишком долго',
  'form.invalid': 'Недействителен',
  'form.number': 'должно быть числом',
  'alert.info': 'Информация',
  'alert.warning': 'Предупреждение',
  'alert.error': 'ошибка',
  'alert.notitle': 's',
  'alert.success': 'успешный',
  'error.receiveerror': 'Ошибка получения информации',
  'errorBoundary.oops': 'Упс!!',
  'errorBoundary.weSearched': 'Желаемая страница не найдена.',
  NextStep: 'Следующий шаг',
  Previous: 'предыдущий',
  FirstName: 'Имя',
  LastName: 'Фамилия',
  BirthDate: 'Дата рождения',
  NationalCode: 'Номер Паспорта',
  Yes: 'Да',
  No: 'Нет',
  Jalali: 'Джалали',
  Miladi: 'Григорианский',
  Hijri: 'иджри',
};
